import { render, staticRenderFns } from "./suiteConfig.vue?vue&type=template&id=d807aade&scoped=true&"
import script from "./suiteConfig.vue?vue&type=script&lang=js&"
export * from "./suiteConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d807aade",
  null
  
)

export default component.exports